// src/themes.js
import { createTheme } from '@mui/material/styles';

export const carrierThemes = {
  interfreight: createTheme({
    palette: {
      primary: {
        main: '#1976d2', // blue
      },
    },
  }),
  fam: createTheme({
    palette: {
      primary: {
        main: '#d32f2f', // red
      },
    },
  }),
};
